<script>
import { Doughnut } from 'vue-chartjs';

const plugin = function(chart) {
	const width = chart.width;
	const height = chart.height;
	const ctx = chart.ctx;
	ctx.restore();

	// fontSize ≈ 12px
	const fontSize = (height / 200).toFixed(2);
	ctx.font = fontSize + "em sans-serif";
	ctx.textBaseline = "middle";

	const text = chart.config.data.text;
	const textX = Math.round((width - ctx.measureText(text).width) / 2);
	const textY = height / 1.9;

	ctx.fillText(text, textX, textY);
	ctx.save();
}

export default {
	extends: Doughnut,
	props: ['data', 'options'],
	mounted () {
		this.addPlugin({
			id: 'my-plugin',
			beforeDraw: plugin,
		})
		this.renderChart(this.data, this.options);
	},
	watch: {
		data() {
			this.renderChart(this.data, this.options);

		}
	}
}
</script>